const DEFAULT_WHATSAPP_SUPPORT = '918143231857';

/** E.164 digits only (no +), for wa.me links. */
export const WHATSAPP_SUPPORT_NUMBER = String(
  process.env.REACT_APP_WHATSAPP_SUPPORT || DEFAULT_WHATSAPP_SUPPORT,
).replace(/\D/g, '') || DEFAULT_WHATSAPP_SUPPORT;

/**
 * @param {string} message
 * @returns {string}
 */
export function buildWhatsAppUrl(message) {
  const text = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_SUPPORT_NUMBER}?text=${text}`;
}
